<div
  class="sl-trigger"
  [class]="'sl-trigger--' + size"
  [class.sl-trigger--focused]="isFocused()"
  [class.sl-trigger--open]="isOpen()"
  [class.sl-trigger--disabled]="disabled"
  [class.sl-trigger--placeholder]="!selectedOption()"
  tabindex="0"
  role="combobox"
  [attr.aria-expanded]="isOpen()"
  (click)="toggle()"
  (focus)="onFocus()"
  (blur)="onBlur()"
>
  @if (addIconLeft) {
    <span class="sl-trigger__icon">
      <ng-content select="[slot='icon-left']"></ng-content>
    </span>
  }

  <span class="sl-trigger__label">{{ displayLabel() || placeholder }}</span>

  @if (multiple() && selectedCount() > 0) {
    <span class="sl-trigger__count">{{ selectedCount() }}</span>
  }

  <span class="sl-trigger__chevron-wrap">
    @if (addIconRight) {
      <ng-content select="[slot='icon-right']"></ng-content>
    } @else {
      <svg class="sl-trigger__chevron"
           xmlns="http://www.w3.org/2000/svg"
           width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M0.35 12.62C0.58 12.86 0.88 13 1.2 13C1.52 13 1.82 12.86 2.05 12.62L8 6.15L13.95 12.62C14.18 12.86 14.48 12.99 14.8 12.99C15.12 12.99 15.42 12.85 15.64 12.61C15.86 12.37 15.99 12.04 15.99 11.7C15.99 11.36 15.87 11.03 15.65 10.78L8.86 3.38C8.63 3.14 8.33 3 8.01 3C7.69 3 7.39 3.14 7.16 3.38L0.35 10.77C0.12 11.01 0 11.35 0 11.69C0 12.03 0.13 12.37 0.35 12.61V12.62Z" fill="currentColor"/>
      </svg>
    }
  </span>
</div>

@if (isOpen()) {
  <div class="sl-dropdown" [ngStyle]="dropdownStyle()" role="listbox">
    @if (!options().length) {
      <div class="sl-dropdown__empty">Aucune option disponible</div>
    }
    @for (opt of options(); track opt.id) {
      @if (multiple() && withCheckboxes) {
        <div class="sl-dropdown__option sl-dropdown__option--checkbox"
             [class.sl-dropdown__option--selected]="isSelectedInMulti(opt)"
             [class.sl-dropdown__option--disabled]="opt.disabled"
             role="option">
          <app-checkbox
            color="mint"
            size="medium"
            [label]="opt.label"
            [state]="opt.disabled ? 'disabled' : 'default'"
            [ngModel]="isSelectedInMulti(opt)"
            (ngModelChange)="toggleMultipleOption(opt, $event)"
            [fullWidth]="true">
          </app-checkbox>
        </div>
      } @else {
        <div class="sl-dropdown__option"
             [class.sl-dropdown__option--selected]="isSelected(opt)"
             [class.sl-dropdown__option--disabled]="opt.disabled"
             role="option"
             (click)="selectOption(opt)">
          {{ opt.label }}
        </div>
      }
    }
  </div>
}